import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { TermsDialogComponent } from './terms-dialog.component';



@NgModule({
  declarations: [
    TermsDialogComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    TranslateModule,
  ],
  exports: [
    TermsDialogComponent
  ]
  // schemas: [
  //   CUSTOM_ELEMENTS_SCHEMA
  // ]
})
export class TermsDialogModule { }
